import { logger } from '../util/logger'
import { browserUtil, tokenService } from '@grndhouse/react-common'
import React from 'react'

export const HomeScreen = (): React.ReactElement => {
  if (!tokenService.hasAccessToken()) {
    logger.debug('redirect to login')
    browserUtil.redirect('/login')
    return <></>
  } else return <></>
}
